<template>
	<v-container class="pa-0">
		<v-row>
			<v-col class="py-0">
				<h1 class="font-weight-bold my-1 my-sm-2 my-md-4 my-lg-8 text-h2 text-md-h1">
					{{ greeting.heading }}
				</h1>
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
export default {
	name: 'Greeting',
	props: {
		user: {
			type: Object,
			default: () => ({})
		}
	},
	computed: {
		greeting() {
			const currentTime = this.moment();
			const name = this.user?.first_name || this.user.name.split(' ')[0];

			if(!currentTime || !currentTime.isValid()) return `Hello, ${name}`;

			const splitAfternoon = 12; // noon
			const splitEvening = 17; // 5pm
			const currentHour = parseFloat(currentTime.format('HH'));

			if(currentHour >= splitAfternoon && currentHour <= splitEvening) {
				return {
					heading: `Good afternoon, ${name}`,
					subHeading: 'Get our there and enjoy your pass!'
				};
			}

			if(currentHour >= splitEvening) {
				return {
					heading: `Good evening, ${name}`,
					subHeading: 'Take a look at your pass for things to do tomorrow.'
				};
			}

			return {
				heading: `Good morning, ${name}`,
				subHeading: "It's going to be a great day, enjoy your pass."
			};
		}
	}
};
</script>

<style lang="scss" scoped>
h1 {
	// text-shadow: 1px 1px 3px rgba(82, 149, 48, 0.7);
}
</style>
